import React from 'react';

import Image from '../../../Commons/Image/Image';
import CHARCAS from '../../../../assets/swiss-medical-center/centro_odontologico_charcas.jpg';

import styles from './ChacasOdontoCenter.module.scss';

const ChacasOdontoCenter = () => {
  return (
    <div className={styles.chacas_odonto_center}>
      <h3>Centro Odontológico Charcas</h3>
      <p>
        <strong className={styles.chacas_odonto_center__redText}>Dirección: </strong>Charcas 3391,
        C.P. 1425, Capital Federal
      </p>
      <p>
        <strong className={styles.chacas_odonto_center__redText}>Turnos: </strong>0810-333-8876
      </p>
      <Image
        src={CHARCAS}
        alt='Centro Odontologico Charcas'
        title='Centro Odontologico Charcas'
        classes={styles.chacas_odonto_center__image}
      />
      <p>
        <strong>Especialidades</strong>
      </p>
      <ul>
        <li>Guardia Odontológica las 24 hs, los 365 días del año</li>
        <li>Odontología General</li>
        <li>Endodoncia</li>
        <li>Periodoncia</li>
        <li>Odontopediatría</li>
        <li>Ortodoncia para menores y adultos</li>
        <li>Implantes dentales</li>
        <li>Cirugía dentomaxilar</li>
        <li>Blanqueamiento dental</li>
        <li>Prótesis Dentales</li>
      </ul>
      <p>
        <strong className={styles.chacas_odonto_center__redText}>
          Días y horarios de atención
        </strong>
      </p>
      <p>Lunes a Viernes | 08 hs. a 20 hs.</p>
      <p>Sábados | 08 hs. a 14 hs.</p>
    </div>
  );
};

export default ChacasOdontoCenter;
